/* ---------- Galería propia: dots de paginación sincronizados con el slider móvil ---------- */
(function initViccaGallery() {
  document.querySelectorAll('[data-vicca-gallery]').forEach((gallery) => {
    const list = gallery.querySelector('[data-vicca-gallery-list]');
    const dotsContainer = gallery.querySelector('[data-vicca-gallery-dots]');
    if (!list || !dotsContainer) return;
    const items = Array.from(list.querySelectorAll('[data-vicca-gallery-item]'));
    if (items.length < 2) return;

    dotsContainer.hidden = false;
    dotsContainer.setAttribute('role', 'tablist');
    items.forEach((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vicca-gallery__dot' + (index === 0 ? ' vicca-gallery__dot--active' : '');
      dot.setAttribute('aria-label', window.viccaStrings?.galleryGoTo || 'Ir a la foto ' + (index + 1));
      dot.addEventListener('click', () => {
        item.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      dotsContainer.appendChild(dot);
    });

    const dotEls = Array.from(dotsContainer.children);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const index = items.indexOf(entry.target);
          if (index === -1) return;
          dotEls.forEach((dot, i) => dot.classList.toggle('vicca-gallery__dot--active', i === index));
        });
      },
      { root: list, threshold: 0.6 }
    );
    items.forEach((item) => observer.observe(item));
  });
})();

/* ---------- Galería: al cambiar de tono, la foto de esa variante pasa a primer plano ---------- */
(function syncGalleryWithVariant() {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data && event.data.variant;
    const mediaId = variant && variant.featured_media && variant.featured_media.id;
    if (!mediaId) return;
    document.querySelectorAll('[data-vicca-gallery-list]').forEach((list) => {
      const item = list.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      list.querySelectorAll('[data-tone-group]').forEach((el) => {
        el.classList.toggle('is-active-tone', String(el.dataset.toneGroup) === String(variant.id));
      });
      list.classList.toggle('has-active-tone', !!list.querySelector('.is-active-tone'));
      if (window.matchMedia('(min-width: 990px)').matches) {
        const group = [...list.querySelectorAll('[data-tone-group="' + variant.id + '"]')];
        const toMove = group.length ? group : [item];
        toMove.reverse().forEach((el) => list.prepend(el));
        const top = list.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
      } else {
        // Solo desplazamiento horizontal del slider: nunca mover la página verticalmente.
        list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
      }
    });
  });
})();

if (!customElements.get('vicca-sticky-add-to-cart')) {
  customElements.define(
    'vicca-sticky-add-to-cart',
    class ViccaStickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.trigger = document.querySelector('[data-vicca-buy-buttons]');
        this.select = this.querySelector('[data-vicca-sticky-variant-select]');
        this.priceEl = this.querySelector('[data-vicca-sticky-price]');
        this.submitButton = this.querySelector('[data-vicca-sticky-submit]');
        this.submitLabel = this.querySelector('[data-vicca-sticky-submit-label]');
        this.mainForm = document.getElementById(this.dataset.productFormId);

        if (this.trigger) {
          // Respaldo por scroll: algunos navegadores móviles no disparan el observer con fiabilidad.
          this.onScroll = () => {
            if (this.scrollTicking) return;
            this.scrollTicking = true;
            requestAnimationFrame(() => {
              this.scrollTicking = false;
              const rect = this.trigger.getBoundingClientRect();
              this.classList.toggle('active', rect.bottom < 0);
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('active', !entry.isIntersecting && entry.boundingClientRect.top < 0);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(this.trigger);
        }

        if (this.select) {
          this.select.addEventListener('change', this.onVariantChange.bind(this));
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event.data || !event.data.variant) return;
            this.syncFromVariant(event.data.variant);
          });
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      onVariantChange(event) {
        const variantId = event.target.value;
        if (!this.mainForm) return;
        const idInput = this.mainForm.querySelector('input[name="id"]');
        if (idInput) {
          idInput.value = variantId;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncFromVariant(variant) {
        if (this.select && this.select.value !== String(variant.id)) {
          this.select.value = variant.id;
        }
        if (this.priceEl && variant.price !== undefined) {
          this.priceEl.textContent = formatMoney(variant.price, window.Shopify?.money_format || '${{amount}}');
        }
        const available = variant.available !== false;
        if (this.submitButton) this.submitButton.disabled = !available;
        if (this.submitLabel) {
          this.submitLabel.textContent = available
            ? window.viccaStrings?.stickyAddToCart || window.viccaStrings?.addToCart || this.submitLabel.textContent
            : window.viccaStrings?.soldOut || this.submitLabel.textContent;
        }
      }
    }
  );
}

function formatMoney(cents, format) {
  const amount = (cents / 100).toFixed(2).replace('.', ',');
  return format.replace('{{amount}}', amount);
}

/* ---------- Badge de stock: se actualiza al cambiar de variante ---------- */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const badge = document.querySelector('[data-vicca-stock-badge]');
    if (!badge || !event.data || !event.data.variant) return;
    const available = event.data.variant.available !== false;
    badge.classList.toggle('vicca-product-main__stock--in', available);
    badge.classList.toggle('vicca-product-main__stock--out', !available);
    const label = badge.querySelector('.vicca-product-main__stock-label');
    if (label && window.viccaStrings) {
      label.textContent = available ? window.viccaStrings.inStock : window.viccaStrings.soldOut;
    }
  });
}

/* ---------- Guía de tallas: modal ---------- */
document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-vicca-size-guide-open]');
  if (opener) {
    const modal = document.getElementById(opener.dataset.modalId);
    if (modal && typeof modal.showModal === 'function') modal.showModal();
    return;
  }
  const closer = event.target.closest('[data-vicca-size-guide-close]');
  if (closer) {
    const modal = closer.closest('dialog');
    if (modal) modal.close();
    return;
  }
});
document.addEventListener(
  'click',
  (event) => {
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('vicca-size-finder__modal')) {
      const rect = event.target.getBoundingClientRect();
      const inside =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!inside) event.target.close();
    }
  },
  true
);

/* ---------- Recomendador de talla ---------- */
if (!customElements.get('vicca-size-finder')) {
  customElements.define(
    'vicca-size-finder',
    class ViccaSizeFinder extends HTMLElement {
      connectedCallback() {
        this.rules = [];
        try {
          this.rules = JSON.parse(this.dataset.rules || '[]');
        } catch (error) {
          this.rules = [];
        }
        this.submitBtn = this.querySelector('[data-vicca-size-finder-submit]');
        this.result = this.querySelector('[data-vicca-size-finder-result]');
        this.pickBtn = this.querySelector('[data-vicca-size-finder-pick]');
        this.heightInput = this.querySelector('input[name="height"]');
        this.weightInput = this.querySelector('input[name="weight"]');
        this.fitSelect = this.querySelector('select[name="fit"]');

        if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
        if (this.pickBtn) this.pickBtn.addEventListener('click', this.onPick.bind(this));
      }

      onSubmit() {
        const height = parseFloat(this.heightInput?.value);
        const fit = this.fitSelect?.value || 'any';
        if (!height) {
          this.showResult(window.viccaStrings?.sizeFinderError || 'Introduce tu altura.');
          return;
        }

        const match =
          this.rules.find((rule) => height >= rule.min_height && height <= rule.max_height && rule.fit === fit) ||
          this.rules.find((rule) => height >= rule.min_height && height <= rule.max_height && rule.fit === 'any');

        if (!match) {
          this.showResult(window.viccaStrings?.sizeFinderNoMatch || 'No encontramos una talla exacta, contáctanos.');
          this.pickBtn.hidden = true;
          return;
        }

        this.suggestedSize = match.size;
        const template = window.viccaStrings?.sizeFinderResult || 'Tu talla recomendada: {{size}}';
        this.showResult(template.replace('{{size}}', match.size));
        this.pickBtn.hidden = false;
      }

      showResult(text) {
        if (!this.result) return;
        this.result.textContent = text;
        this.result.hidden = false;
      }

      onPick() {
        if (!this.suggestedSize) return;
        const labels = document.querySelectorAll('.product-form__input--pill label, .product-form__input label, variant-radios label');
        let picked = false;
        labels.forEach((label) => {
          const text = label.textContent.trim();
          if (!picked && text.toUpperCase() === this.suggestedSize.toUpperCase()) {
            const input = label.previousElementSibling;
            if (input && input.tagName === 'INPUT') {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              picked = true;
            } else if (label.control) {
              label.control.checked = true;
              label.control.dispatchEvent(new Event('change', { bubbles: true }));
              picked = true;
            }
          }
        });
        const dialog = this.closest('dialog');
        if (dialog) dialog.close();
      }
    }
  );
}

/* ---------- Cross-sell "Combínalo con": añadir por Ajax y abrir el drawer ---------- */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-vicca-cross-sell-add]');
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  const originalText = button.textContent;
  button.disabled = true;
  button.textContent = window.viccaStrings?.addingToCart || '...';

  const body = JSON.stringify({
    items: [{ id: variantId, quantity: 1 }],
    sections: cart ? cart.getSectionsToRender().map((section) => section.id) : undefined,
    sections_url: window.location.pathname,
  });

  fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body,
  })
    .then((response) => response.json())
    .then((response) => {
      button.disabled = false;
      button.textContent = originalText;
      if (response.status) return;
      if (cart) {
        cart.renderContents ? cart.renderContents(response) : null;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vicca-cross-sell', cartData: response });
      }
    })
    .catch(() => {
      button.disabled = false;
      button.textContent = originalText;
    });
});

/* ---------- INCI por tono: mostrar la lista de la variante elegida ---------- */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event.data && event.data.variant;
    if (!variant) return;
    const lists = document.querySelectorAll('[data-variant-ingredients]');
    if (!lists.length) return;
    lists.forEach((el) => { el.hidden = String(el.dataset.variantIngredients) !== String(variant.id); });
  });
}
